<template>
    <svg class="icon" role="img" :viewBox="viewBox || '0 0 48 48'" :style="{ width: xSize.width, height: xSize.height }" :fill="color || 'currentColor'">
        <slot :filled="filled"></slot>
    </svg>
</template>

<script>
const isNumeric = (num) => {
    if (typeof num === 'number') {
        return true;
    }
    if (typeof num === 'string' && /^[0-9]+$/.test(num)) {
        return true;
    }
    return false;
};

const getUnit = (str) => (str + '').match(/[a-z]+$/)?.[0];
const getSize = (v, unit) => unit ? v + unit : +v / 200 + 'rem';

export default {
    props: [
        'color',
        'width',
        'height',
        'filled',
        'viewBox',
    ],
    computed: {
        xSize() {
            const { width, height, viewBox } = this;

            // 宽高都给了的情况，直接应用
            if (width && height) {
                const getSize = (v) => isNumeric(v) ? +v / 200 + 'rem' : v;
                return {
                    width: getSize(width),
                    height: getSize(height),
                };
            }


            /**
             * 基于width, height, viewBox算出对边长度
             */

            const [, , viewWidth, viewHeight] = viewBox.split(' ').map(v => +v);

            if (width && !height) {
                const unit = getUnit(width);
                const w = Number.parseFloat(width);
                const scale = viewHeight / viewWidth;
                const h = w * scale;
                return {
                    width: getSize(w, unit),
                    height: getSize(h, unit),
                };
            }

            if (height && !width) {
                const unit = getUnit(height);
                const h = Number.parseFloat(height);
                const scale = viewWidth / viewHeight;
                const w = h * scale;
                return {
                    width: getSize(w, unit),
                    height: getSize(h, unit),
                };
            }

            if (viewWidth > viewHeight) {
                return {
                    width: '1em',
                    height: viewHeight / viewWidth + 'em',
                };
            }

            if (viewHeight > viewWidth) {
                return {
                    width: viewWidth / viewHeight + 'em',
                    height: '1em',
                };
            }

            return {
                width: '1em',
                height: '1em',
            };
        },
    },
};
</script>

<style scoped>
    .icon {
        display: inline-block;
        vertical-align: middle;
        box-sizing: border-box;
    }
</style>
